var map = {
	"./mnm08.csv": "./src/data/mnm/mnm08.csv",
	"./mnm09.csv": "./src/data/mnm/mnm09.csv",
	"./mnm11.csv": "./src/data/mnm/mnm11.csv",
	"./mnm14.csv": "./src/data/mnm/mnm14.csv",
	"./mnm15.csv": "./src/data/mnm/mnm15.csv",
	"./mnm18.csv": "./src/data/mnm/mnm18.csv",
	"./mnm22.csv": "./src/data/mnm/mnm22.csv",
	"./mnm23.csv": "./src/data/mnm/mnm23.csv",
	"./mnm25.csv": "./src/data/mnm/mnm25.csv",
	"./mnm27.csv": "./src/data/mnm/mnm27.csv",
	"./mnm29.csv": "./src/data/mnm/mnm29.csv",
	"./mnm31.csv": "./src/data/mnm/mnm31.csv",
	"./mnm33.csv": "./src/data/mnm/mnm33.csv",
	"./mnm34.csv": "./src/data/mnm/mnm34.csv"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	var module = __webpack_require__(id);
	return module;
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error('Cannot find module "' + req + '".');
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./src/data/mnm sync recursive ^\\.\\/mnm.*\\.csv$";